import { Compare } from '@components/ui/Compare';
import { CERTIFICATIONS } from '@constants/index';
import { motion } from 'framer-motion';

const Certs = () => {
  return (
    <div id="certs">
      <div className="min-h-screen flex flex-col items-center py-20 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-sans text-3xl lg:text-4xl font-bold z-10 mb-4"
        >
          <span>Certifi</span>
          <span className="text-purple">cations</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-gray-400 max-w-xl mb-12 text-sm lg:text-base"
        >
          Professional credentials validating expertise across cloud, development, and agile methodologies
        </motion.p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 px-4">
          {CERTIFICATIONS.map((cert, index) => (
            <motion.div
              key={cert.id}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
              className="flex flex-col items-center"
            >
              <Compare
                initialSliderPercentage={90}
                coverComponent={
                  <div className="h-full w-full bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-600 flex flex-col justify-center items-center p-8 text-center">
                    <h3 className="text-xl lg:text-2xl font-bold text-white mb-3">{cert.title}</h3>
                    <p className="text-sm text-white/70 mb-4 max-w-[280px]">{cert.description}</p>
                    <div className="flex items-center gap-2 text-xs text-white/60">
                      <span className="px-2 py-0.5 rounded-full bg-white/10 border border-white/20">{cert.issuer}</span>
                      <span className="px-2 py-0.5 rounded-full bg-white/10 border border-white/20">{cert.year}</span>
                    </div>
                    <div className="flex flex-wrap gap-1.5 mt-4 justify-center">
                      {cert.skills.map((skill) => (
                        <span
                          key={skill}
                          className="text-[10px] px-2 py-0.5 rounded-full bg-white/10 text-white/80 border border-white/15"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                }
                secondImage={cert.img}
                firstImageClassName="object-cover object-left-top"
                secondImageClassname="object-cover"
                className="h-[250px] w-[200px] md:h-[500px] md:w-[500px] rounded-xl overflow-hidden shadow-2xl shadow-purple-500/10"
                slideMode="hover"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certs;
